import { useEffect } from "react";
import MobilePeopleCell from "./MobilePeopleCell";
import { getDocPersons } from "../../../api/papers";

export default function MobilePeopleCellLoader({ dns, value, onChange, single }) {
  useEffect(() => {
    if (!dns || value.length > 0) return;

    (async () => {
      try {
        const list = await getDocPersons(dns);
        const mapped = list.map((p) => ({
          id: p.user.id,
          name:
            p.user.name || `${p.user.last_name ?? ""}${p.user.first_name ?? ""}`,
        }));
        onChange(mapped);
      } catch (error) {
        console.error("문서 담당자 로드 오류:", error);
      }
    })();
  }, [dns, value.length, onChange]);

  return <MobilePeopleCell value={value} onChange={onChange} single={single} />;
}

